import proj4 from 'proj4';

// Ensure projections are defined (in case coordinateUtils hasn't loaded yet)
if (!proj4.defs('EPSG:2240')) {
  proj4.defs('EPSG:2240', '+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=700000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs');
}

/**
 * Convert meters to US Survey Feet
 */
export function metersToFeet(m) {
  return m * 3.28084;
}

/**
 * Format a distance with both feet and meters
 */
export function formatDistance(meters) {
  const feet = metersToFeet(meters);
  if (feet < 1000) {
    return `${feet.toFixed(1)} ft (${meters.toFixed(1)} m)`;
  }
  return `${feet.toLocaleString('en-US', { maximumFractionDigits: 1 })} ft (${meters.toFixed(1)} m)`;
}

/**
 * Format feet-only distance
 */
export function formatFeet(meters) {
  const feet = metersToFeet(meters);
  if (feet < 1000) {
    return `${feet.toFixed(1)} ft`;
  }
  return `${feet.toLocaleString('en-US', { maximumFractionDigits: 1 })} ft`;
}

/**
 * Format area in square feet and acres
 */
export function formatArea(sqFeet) {
  const acres = sqFeet / 43560;
  return {
    sqFt: sqFeet.toLocaleString('en-US', { maximumFractionDigits: 1 }),
    acres: acres.toFixed(3)
  };
}

/**
 * Calculate polygon area in square feet using Shoelace formula
 * on Georgia State Plane West projected coordinates.
 * This gives accurate area in US Survey Feet.
 */
export function calculatePolygonAreaSqFt(latlngs) {
  if (!latlngs || latlngs.length < 3) return 0;

  // Project all points to Georgia West State Plane (US Survey Feet)
  const projected = latlngs.map(ll =>
    proj4('EPSG:4326', 'EPSG:2240', [ll.lng, ll.lat])
  );

  // Shoelace formula
  let area = 0;
  const n = projected.length;
  for (let i = 0; i < n; i++) {
    const j = (i + 1) % n;
    area += projected[i][0] * projected[j][1];
    area -= projected[j][0] * projected[i][1];
  }
  return Math.abs(area) / 2;
}

/**
 * Calculate perimeter in feet using map.distance() for each segment
 */
export function calculatePerimeterMeters(latlngs, map) {
  if (!latlngs || latlngs.length < 2) return 0;

  let total = 0;
  for (let i = 0; i < latlngs.length; i++) {
    const j = (i + 1) % latlngs.length;
    total += map.distance(latlngs[i], latlngs[j]);
  }
  return total;
}
